export default __webpack_public_path__ + "static/media/SignInBG.83fcd96c.png";